import { SUCCESS_MESSAGES, responseErrorToString } from '@zorro/common-utils';
import { Stack, Text } from '@zorro/web/design-system';
import {
  callEndpoint,
  showErrorNotification,
  showSuccessNotification,
  useLoadingOverlay,
} from '@zorro/web/ui-utils';
import pluralize from 'pluralize';

import { ModalFooter } from '../../../index';
import { RecordForActions } from '../EmployeeActionsUtils';

type CobraTerminationEmailFormProps = {
  recordsForActions: RecordForActions[];
  onClose: () => void;
  onSuccess: () => void;
};

const CobraTerminationEmailForm = ({
  recordsForActions,
  onClose,
  onSuccess,
}: CobraTerminationEmailFormProps) => {
  const { startLoading, stopLoading, isLoading } = useLoadingOverlay();

  async function handleSubmit() {
    startLoading();
    const employeeIds: string[] = recordsForActions.map(
      (record) => record.employeeId
    );

    try {
      await callEndpoint({
        method: 'employeesControllerSendCobraEmails',
        params: [{ employeeIds }],
      });

      showSuccessNotification({
        message: SUCCESS_MESSAGES.getEmailSentSuccessfullyMessage(
          recordsForActions.length
        ),
      });

      onSuccess();
    } catch (error) {
      showErrorNotification({ message: responseErrorToString(error) });
    }
    stopLoading();
  }

  const submitText = `Send ${pluralize('email', recordsForActions.length)}`;

  return (
    <Stack gap="xxl">
      <Text>
        "The email includes a COBRA notice and explains post-employment
        coverage," you clearly differentiate between providing the official
        document and offering the explanatory information
      </Text>
      <ModalFooter
        onClose={onClose}
        submitVariant="primary"
        submitText={submitText}
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export { CobraTerminationEmailForm };
